<template>
    <a-tooltip placement="topLeft">
        <template slot="title">
            <span>{{value}}</span>
        </template>
        {{ value | ellipsis(length) }}
    </a-tooltip>
</template>

<script>

    import {cutStrByFullLength} from '@/components/Ellipsis/string-utils';

    export default {
        name: 'EEllipsis',
        props: {
            value: {
                type: String,
                required: false,
            },
            length: {
                type: Number,
                required: false,
                default: 25,
            }
        },
        filters: {
            ellipsis: function (value, length) {
                //console.log('value = ' + value + '    length = ' + length);
                //console.log('指定长度字符串 = ' + cutStrByFullLength(value, length));
                return cutStrByFullLength(value, length);
            }
        },
    }
</script>

<style scoped>

</style>
